/*Copyright (c) 2023. Honeywell International, Inc. All rights reserved.
This file contains trade secrets of Honeywell International, Inc. 
No part may be reproduced or transmitted in any form by any means or for any purpose without the express written permission of Honeywell. */
import "../SharedComponents/InfoComponent/InfoComponent.scss";
import ProfileIcon from "../../../src/images/LogoShow.png";
import { Grid, Stack } from "@mui/material";
import { AppDispatch, RootState } from "../../store";
import { useDispatch, useSelector } from "react-redux";
import { useEffect, useRef, useState } from "react";
import { getLocalTime } from "../../utils/methods/getLocalTime";
import { IErrorProps, Tenant } from "../../models";

import {
  Button,
  CardContent,
  MoreVerticalIcon,
  ContextualMenu,
  ContextualMenuItem,
  Card,
  CardHeader,
  Label,
  TextOverflow
} from "@forge/common";
import {
  getSettingsByTenantId,
  getTenantDetailsByTenantId,
  setStatusforTenant
} from "../../store/Tenant/tenant-actions";
import CircleIcon from "@mui/icons-material/Circle";
import { useNavigate } from "react-router";
import { MoreInfo } from "./MoreInfo";
import SettingMetaDataDTO from "../../models/SettingDTO";
import Loader from "../Loader/Loader";
import ErrorHandlingComponent from "../SharedComponents/ErrorHandlingComponent";
import { setErrorPopupsusingErrorCode } from "./setErrorPopupsusingErrorCode";
import { serverErrorClose } from "../SharedComponents/serverErrorClose";
import updateErrorList from "../../utils/methods/updateErrorList";
import { getStatusDetails, StatusCode } from "../../models/apiModels/Tenant";
import { GenerateCertificate } from "./GenerateCertificate";
import { useFlags } from "launchdarkly-react-client-sdk";
import { useTranslation } from "@scuf/localization";
import { localeKeyMap } from "../../localization/keys";
interface Iprops {
  className: string;
  currentLogo: string;
}

const TenantInfoComponent = (props: Iprops) => {
  const flags = useFlags();
  const generateCertificateEnabled = flags?.adminPortalUiGenerateCsr;
  const tenantData: Tenant = useSelector(
    (state: RootState) => state.cart.tenantDeatailsByTenantId
  );

  const [name, setName] = useState(tenantData.tenantName);
  const [status, setStatus] = useState(tenantData.status);
  const [headquarterAddress, setHeadquarterAddress] = useState(
    tenantData.headquarterAddress
  );
  const [country, setCountry] = useState(tenantData.address?.country);
  const [region, setRegion] = useState(tenantData.region);
  const [state, setState] = useState(tenantData.address?.state);
  const [tenantID, setTenantID] = useState(tenantData.tenantId);
  const [currency, setCurrency] = useState(tenantData.currency);
  const [selectedProducts, setSelectedProducts] = useState(
    tenantData.products
      ?.map((x: { productName: string }) => x.productName)
      .join(", ")
  );
  const [data, setData] = useState<Array<SettingMetaDataDTO>>([]);
  const [moreInfo, setMoreInfo] = useState(false);
  const [dataCenter, setDataCenter] = useState(tenantData.datacenter);
  const [timeZone, setTimeZone] = useState(tenantData.timezone);
  const [createdOn, setCreatedOn] = useState(tenantData.lastUpdatedTimeStamp);
  const [zipCode, setZipCode] = useState(tenantData.address?.zipcode);
  const { statusName, statusColor } = getStatusDetails(
    status ?? StatusCode.noTenant
  );
  const [generateCertificate, setGenerateCertificate] = useState(false);

  ///////////////Error Handling////////////////////////
  const [isLoading, setIsLoading] = useState(false);
  const toastErrors = useRef<IErrorProps[]>([]);
  const [errorListGlobal, setErrorListGlobal] = useState<Array<IErrorProps>>(
    []
  );
  const [openDialogNoURLError, setOpenDialogNoURLError] = useState(false);
  const [openDialogServerError, setOpenDialogServerError] = useState(false);
  const [openToastError, setOpenToastError] = useState(false);
  const anchorRef = useRef<any>(null);
  const userPermissions = useSelector(
    (state: RootState) => state.user.userPermissions
  );
  const [showMoreInfoIcon, setShowMoreInfoIcon] = useState(false);
  const [canUserUpdatetenant, setCanUserUpdatetenant] = useState(false);
  const [t] = useTranslation();

  const onDialogForServerCloseHandler = () => {
    serverErrorClose({
      errorListGlobal,
      setOpenDialogServerError,
      setErrorListGlobal
    });
  };
  const onDialogForNOURLCloseHandler = () => {
    setOpenDialogNoURLError(false);
  };
  const handleToastBarClose = (
    event?: React.SyntheticEvent | Event,
    reason?: string
  ) => {
    if (reason === "clickaway") {
      return;
    }
    setOpenToastError(false);
  };
  // istanbul ignore next
  useEffect(() => {
    setErrorPopupsusingErrorCode({
      errorListGlobal,
      setOpenDialogNoURLError,
      setOpenToastError,
      setOpenDialogServerError,
      openDialogNoURLError,
      openToastError,
      openDialogServerError
    });
  }, [errorListGlobal]);

  //////////////Error Handling////////////////////////

  const moreInfoCloseHandler = () => {
    setMoreInfo(false);
  };

  const moreInfoHandeller = () => {
    setIsLoading(true);
    dispatch(getSettingsByTenantId(tenantId))
      ?.unwrap()
      ?.then((response: SettingMetaDataDTO[]) => {
        setData(response);
        setMoreInfo(true);
      })
      .catch((error: any) => {
        setErrorListGlobal((prevState) =>
          updateErrorList(error, [...prevState])
        );
      })
      .finally(() => {
        setIsLoading(false);
      });
  };

  const statusCallHandler = () => {
    setIsLoading(true);
    dispatch(setStatusforTenant(tenantId))
      .unwrap()
      .then(() => {
        dispatch(getTenantDetailsByTenantId({ tenantId: tenantId }))
          .unwrap()
          .then((response: any) => {})
          .catch((err) => {
            setErrorListGlobal((prevState) =>
              updateErrorList(err?.error?.response, [...prevState])
            );
          })
          .finally(() => {
            setIsLoading(false);
          });
      })
      .catch((error: any) => {
        setErrorListGlobal((prevState) =>
          updateErrorList(error, [...prevState])
        );
      })
      .finally(() => {
        setIsLoading(false);
      });
  };

  const [tenantLogo, setTenantLogo] = useState<string>(props.currentLogo);
  const dispatch: AppDispatch = useDispatch();
  const tenantId = tenantData.tenantId;
  const navigate = useNavigate();

  useEffect(() => {
    setName(tenantData?.tenantName);
    setStatus(tenantData?.status);
    setHeadquarterAddress(tenantData?.headquarterAddress);
    setCountry(tenantData?.address?.country);
    setRegion(tenantData?.region);
    setState(tenantData?.address?.state);
    setTenantID(tenantData?.tenantId);
    setCurrency(tenantData?.currency);
    setSelectedProducts(
      tenantData?.products
        ?.map((x: { productName: string }) => x.productName)
        .join(", ")
    );
    setDataCenter(tenantData?.datacenter);
    setTimeZone(tenantData?.timezone);
    setCreatedOn(
      getLocalTime({
        utcTime: tenantData?.createdon,
        timezone: tenantData?.timezone
      })
    );
    setZipCode(tenantData?.address?.zipcode);
    setTenantLogo(props.currentLogo);
  }, [tenantData, props.currentLogo]);

  const BasicInfoGroup = [
    {
      label: t(localeKeyMap.name),
      fieldData: name
    },
    {
      label: t(localeKeyMap.tenantID),
      fieldData: tenantID
    },
    {
      label: t(localeKeyMap.headquarterAddress),
      fieldData: headquarterAddress
    },
    {
      label: t(localeKeyMap.country),
      fieldData: country
    },
    {
      label: t(localeKeyMap.region),
      fieldData: region
    },
    {
      label: t(localeKeyMap.state),
      fieldData: state
    },
    {
      label: t(localeKeyMap.zipCode),
      fieldData: zipCode
    }
  ];
  const OtherInfoGroup = [
    {
      label: t(localeKeyMap.status),
      fieldData: statusName,
      icon: true
    },
    {
      label: t(localeKeyMap.currency),
      fieldData: currency
    },
    {
      label: t(localeKeyMap.products),
      fieldData: selectedProducts
    },
    {
      label: t(localeKeyMap.dataCenter),
      fieldData: dataCenter
    },
    {
      label: t(localeKeyMap.timeZone),
      fieldData: timeZone
    },
    {
      label: t(localeKeyMap.createdOn),
      fieldData: createdOn
    }
    // Placeholder for css
  ];

  // TODO: Implement edit tenant functionality
  // Edit tenant handler
  // This comes from MenuItem action
  const editTenantHandler = () => {
    // navigate("/setupEditTenant");
    navigate(`/tenant/edit/${tenantId}`);
    // TODO: Implement edit tenant functionality
  };

  // TODO: Implement delete tenant functionality
  // Delete tenant handler
  // This comes from MenuItem action
  const deleteTenantHandler = () => {
    // TODO: Implement delete tenant functionality
  };

  useEffect(() => {
    // Allow More Info Icon to be visible only if user has permission to update tenant settings
    if (userPermissions.can_update_tenant_settings) {
      setShowMoreInfoIcon(true);
    } else {
      setShowMoreInfoIcon(false);
    }
  }, [userPermissions.can_update_tenant_settings]);

  useEffect(() => {
    // Allow Menu bar for Edit to be visible only when user has permission to  update tenant details
    if (userPermissions.can_update_tenant) {
      setCanUserUpdatetenant(true);
    } else {
      setCanUserUpdatetenant(false);
    }
  }, [userPermissions.can_update_tenant]);

  const MenuItem = () => {
    return (
      <>
        <Button
          className="no-border"
          ref={anchorRef}
          variant="quiet-secondary"
          icon={<MoreVerticalIcon strokeWidth={2.5} />}
          aria-label="More"
        />
        <ContextualMenu anchor={anchorRef}>
          {(showMoreInfoIcon === true && (
            <ContextualMenuItem
              as="button"
              id="moreInfo"
              label={t(localeKeyMap.moreInfo)}
              onClick={moreInfoHandeller}
            />
          )) ||
            null}
          {(canUserUpdatetenant && (
            <ContextualMenuItem
              as="button"
              id="edit"
              className="no-border"
              label={t(localeKeyMap.edit)}
              onClick={editTenantHandler}
            />
          )) ||
            null}
          {/* This Delete is not needed for now .Kept this Delete button for future with false && DeleteButton so it will not show for now*/}
          {(false && (
            <ContextualMenuItem
              as="button"
              id="delete"
              label={t(localeKeyMap.delete)}
              onClick={(id, e) => {
                deleteTenantHandler();
              }}
              disabled={true}
            />
          )) ||
            null}
          <ContextualMenuItem
            className="no-border"
            as="button"
            id="publish"
            label={t(localeKeyMap.publish)}
            onClick={statusCallHandler}
            disabled={tenantData.status !== StatusCode.TenantUpdated}
            title={t(localeKeyMap.publishTooltip)}
          >
            {/* <Button
            variant="secondary"
            onClick={statusCallHandler}
            disabled={tenantData.status !== StatusCode.TenantUpdated}
          >
            Publish
          </Button> */}
          </ContextualMenuItem>

          {(showMoreInfoIcon === true && generateCertificateEnabled && (
            <ContextualMenuItem
              as="button"
              id="Generate-Certificate"
              className="no-border"
              label={t(localeKeyMap.generateCertificate)}
              onClick={() => {
                setGenerateCertificate(true);
              }}
            />
          )) ||
            null}
        </ContextualMenu>
      </>
    );
  };


  return (
    <>
      <Card className={`info_box `}>
        <CardContent>
          <Grid
            container
            columnSpacing={{ xs: 1, sm: 2, md: 3 }}
            className="container-tenant-info"
          >
            <Grid
              item
              xs={2}
              sx={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                minHeight: "10rem"
              }}
              className="info_logo color-bg-img-wrapper-tenant-profile"
            >
              <img
                className="
              object-contain 
              "
                src={
                  !tenantLogo
                    ? ProfileIcon
                    : `data:image/jpeg;base64,${tenantLogo}`
                }
                alt="Logo"
              />
            </Grid>

            <Grid item xs={10}>
              <div>
                <CardHeader
                  slotRight={<MenuItem />}
                  title={t(localeKeyMap.basicInformation)}
                  className="p-0"
                />{" "}
                <Stack direction="row">
                  <Grid container>
                    {BasicInfoGroup.map((item) => {
                      return (
                        <Grid
                          item
                          xs={1.7}
                          className="pr-16 sm:pr:4 md:pr-4 lg-pr-8"
                        >
                          <div className="">
                            <Label className="data-viz-subtitle-3">
                              {item.label}
                            </Label>
                          </div>
                          <div>
                            <TextOverflow className="body-2">
                              {String(item.fieldData ?? "")}
                              {/* </Label> */}
                            </TextOverflow>
                          </div>
                        </Grid>
                      );
                    })}
                  </Grid>
                </Stack>
              </div>
              <div>
                <CardHeader className="p-r0 p-l0" title={t(localeKeyMap.otherInformation)} />
                <Stack direction="row">
                  <Grid container>
                    {OtherInfoGroup.map((item) => {
                      return (
                        <Grid
                          item
                          xs={
                            item.label === t(localeKeyMap.timeZone)
                              ? 3.4
                              : 1.7
                          }
                          className="pr-16 sm:pr:4 md:pr-4 lg-pr-8"
                        >
                          <div className="">
                            <Label className="data-viz-subtitle-3">
                              {item.label}
                            </Label>
                          </div>
                          <div
                            style={{ display: "flex", alignItems: "center" }}
                          >
                            {item.icon && (
                              <CircleIcon
                                sx={{ fontSize: "1rem", color: statusColor }}
                              />
                            )}
                            <TextOverflow className="body-2">
                              {item.fieldData?.toString() || ""}
                            </TextOverflow>
                            {/* <p> {item.fieldData} </p> */}
                          </div>
                        </Grid>
                      );
                    })}
                  </Grid>
                  {/* <div className="info-divider">
                  <label className="label-p-padding data-viz-subtitle-3 text-left label-bold  publish-button">
                    Pending Actions
                    <InfoIcon
                      className="icon-publish"
                      strokeWidth={1.5}
                      title="To save changes in the Tenant Setup,please publish the changes 
"
                    />
                  </label>

                  <Button
                    variant="secondary"
                    onClick={statusCallHandler}
                    disabled={tenantData.status !== StatusCode.TenantUpdated}
                  >
                    Publish
                  </Button>
                </div> */}
                </Stack>
              </div>
            </Grid>
            {/* <div className="info_content">{menuItems}</div> */}
          </Grid>
        </CardContent>
      </Card>
      {moreInfo && (
        <MoreInfo
          closeHandler={moreInfoCloseHandler}
          tenantId={tenantID}
          data={data}
        />
      )}

      {generateCertificate && (
        <GenerateCertificate
          closeHandler={() => {
            setGenerateCertificate(false);
          }}
          tenantId={tenantID}
          data={tenantData.products}
        />
      )}

      <ErrorHandlingComponent
        openToast={openToastError}
        onCloseToast={handleToastBarClose}
        errorList={errorListGlobal.concat(toastErrors.current)}
        openServerError={openDialogServerError}
        onCloseServerError={onDialogForServerCloseHandler}
        openNoURL={openDialogNoURLError}
        onCloseNoURL={onDialogForNOURLCloseHandler}
        openDialogforConflict={false}
        onCloseServerConflictError={function (): void {}}
      />
      {isLoading && <Loader />}
    </>
  );
};
export default TenantInfoComponent;
